export class AppReadonlyField extends HTMLElement {
  static get observedAttributes() {
    return ["label", "value", "helper"];
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback() {
    this.render();
  }

  private render() {
    const label = this.getAttribute("label") || "";
    const value = this.getAttribute("value") || this.textContent || "-";
    const helper = this.getAttribute("helper") || "";

    this.innerHTML = `
      <div class="form-group">
        ${label ? `<span class="form-label">${label}</span>` : ""}
        <div class="readonly-field">
          ${value}
        </div>
        ${helper ? `<span class="form-helper">${helper}</span>` : ""}
      </div>
    `;
  }
}

if (!customElements.get("app-readonly-field")) {
  if (!customElements.get("app-readonly-field")) {
    customElements.define("app-readonly-field", AppReadonlyField);
  }
}

export class AppTechnicalValue extends HTMLElement {
  static get observedAttributes() {
    return ["value", "unit", "status", "label"];
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback() {
    this.render();
  }

  private render() {
    const label = this.getAttribute("label") || "";
    const value = this.getAttribute("value") || "-";
    const unit = this.getAttribute("unit") || "";
    const status = this.getAttribute("status") || ""; // 'success', 'warning', 'danger'

    let colorStyle = "";
    if (status === "success") colorStyle = "color: var(--status-success-text);";
    if (status === "warning") colorStyle = "color: var(--status-warning-text);";
    if (status === "danger") colorStyle = "color: var(--status-danger-solid);";

    this.innerHTML = `
      <div style="display: flex; flex-direction: column; gap: 2px;">
        ${label ? `<span class="text-caption" style="text-transform: uppercase; font-weight: 600;">${label}</span>` : ""}
        <div class="technical-value">
          <span class="technical-value-num" style="${colorStyle}">${value}</span>
          ${unit ? `<span class="technical-value-unit">${unit}</span>` : ""}
        </div>
      </div>
    `;
  }
}

if (!customElements.get("app-technical-value")) {
  if (!customElements.get("app-technical-value")) {
    customElements.define("app-technical-value", AppTechnicalValue);
  }
}
